module.exports = __webpack_public_path__ + "img/dynamic1.2414203d.png";